
import React, { useRef } from 'react'

import { trigger } from '../../events/customEvents'

const useOnScreen = (options) =>
{
    const initialVisibility = options.items.reduce(
        (acc, item) => ({ ...acc, [`auction-list-item-${item.itemIdx}`]: true }),
        {}
    )
    const [visible, setVisible] = React.useState(initialVisibility)
    const observer = useRef(
        new IntersectionObserver((entries) =>
        {
            const newState = entries.reduce((acc, { target, isIntersecting }) =>
            {
                return {
                    ...acc,
                    [target.className]: isIntersecting
                }
            }, {})
            console.log("new state", newState);
            if (newState[Object.keys(newState)[0]])
            {
                trigger('auctionListImpression', { auctionListIndex: Object.keys(newState)[0].substring(Object.keys(newState)[0].lastIndexOf('-') + 1) })
            }
            setVisible((state) => ({
                ...state,
                ...newState
            }));
        }, options)
    )

    const observeEl = (ref) =>
    {
        if (ref.current)
        {
            observer.current.observe(ref.current)
        }
    }

    const unobserveEl = (ref) =>
    {
        if (ref.current)
        {
            observer.current.unobserve(ref.current)
        }
    }

    return [visible, observeEl, unobserveEl]
}

export { useOnScreen }
